module.exports = __webpack_public_path__ + "img/ar-vr-reflect.296b2936.png";